/**
 * Эндпоинты для работы с пользователями
 */
export const USER_ENDPOINTS = {
  /** GET /v1/user/me - Получить данные текущего пользователя */
  me: "/v1/users/me",
  /** GET /v1/users/{userName} - Получить публичный профиль пользователя */
  details: (userName: string) => `/v1/users/${userName}`,
  /** GET /v1/users/{userId}/consume - Получить consume контент пользователя с пагинацией */
  consume: (userId: string) => `/v1/users/${userId}/consume`,
  /** POST /v1/users/{userName}/follow - Подписаться на пользователя */
  follow: (userName: string) => `/v1/users/${userName}/follow`,
  /** DELETE /v1/users/{userName}/follow - Отписаться от пользователя */
  unfollow: (userName: string) => `/v1/users/${userName}/follow`,
  /** GET /v1/users/followers - Получить список подписчиков пользователя */
  followers: (userName: string) => `/v1/users/${userName}/followers`,
  /** GET /v1/users/following - Получить список подписок пользователя */
  following: (userName: string) => `/v1/users/${userName}/following`,
  /** PATCH /v1/users/me/language - Обновить язык пользователя */
  updateLanguage: "/v1/users/me/language",
  /** PATCH /v1/users/me/theme - Обновить тему пользователя */
  updateTheme: "/v1/users/me/theme",
} as const;
